module.exports = __webpack_public_path__ + "img/141.7194111a.jpg";